<script setup lang="ts">
import { onMounted, ref } from "vue";
import ExitModalBtn from "./ExitModalBtn.vue";

defineProps<{
  url: string;
}>();
const frame = ref<HTMLIFrameElement | null>(null);
const emit = defineEmits(["close"]);
const loaded = ref(false);
onMounted(() => {
  if (frame.value) {
    frame.value.addEventListener("load", () => {
      loaded.value = true;
    });
  }
});
</script>
<template>
  <Teleport to="body">
    <div class="modal-area">
      <div v-show="loaded" class="modal-base">
        <div class="content">
          <iframe ref="frame" :src="url" frameborder="0"></iframe>
        </div>
        <ExitModalBtn class="exit-btn" @click="emit('close')" />
      </div>
      <div v-show="!loaded" class="loader"></div>
    </div>
  </Teleport>
</template>
<style scoped>
.modal-area {
  width: 100vw;
  height: 100%;
  height: 100dvh;
  left: 0;
  top: 0;
  position: absolute;
  background: rgba(41, 41, 41, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
}

.modal-base {
  width: 560px;
  height: 665px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;
  box-shadow:
    0px 11px 15px 0px rgba(0, 0, 0, 0.2),
    0px 9px 46px 0px rgba(0, 0, 0, 0.12),
    0px 24px 38px 0px rgba(0, 0, 0, 0.14);
  background: #fff;
  border-radius: 20px;
}

.modal-base iframe {
  width: 1920px;
  height: 1080px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  position: relative;
  top: -240px;
  left: -680px;
  /* transform: translateX(calc(-50% + 5px)); */
}

@media (max-width: 560px) {
  .modal-base iframe {
    width: 100%;
    height: 1080px;
    top: -240px;
    left: 0;
    /* transform: tra; */
  }
}

.exit-btn {
  right: 16px !important;
  top: 16px !important;
}

.content {
  max-height: 635px;
  overflow: hidden;
}

.loader {
  width: 48px;
  height: 48px;
  border: 5px solid #fff;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
